import styled from "styled-components";
import {
  Content,
  ItemList,
  ContentItem,
} from "../../PointStandardContent/PointStandardContent.style";

export const ModalPointStandardBox = styled.div`
  width: 100%;
  display: flex;
  padding: 20px 20px 10px;
  flex-direction: column;

  ${Content} {
    gap: 24px;
  }

  ${ContentItem} {
    & > span {
      padding-left: 10px;
    }
    ${ItemList} {
      width: 100%;
      padding: 16px;
      box-shadow: none;
      background: ${(props) => props.theme.colors.mainBg};
    }
  }
`;
